import React from 'react';

const Education = () => {
  const education = [
    {
      period: "2022 - 2025",
      title: "Webbutvecklare Program",
      institution: "Karlstads Universitet",
      description: "Universitetsexamen med fokus på modern webbutveckling, databaser och mjukvaruutveckling."
    },
    {
      period: "2018 - 2021",
      title: "Industriprogrammet - Maskinteknik",
      institution: "Taserudsgymnasiet",
      description: "Gymnasieexamen med inriktning på maskinteknik och teknisk design."
    }
  ];

  const certifications = [
    {
      name: "AWS Cloud Practitioner",
      issuer: "Amazon Web Services",
      year: "2025"
    },
    {
      name: "Agile Methodology",
      issuer: "Scrum Institute",
      year: "2025"
    },
    
  ];

  return (
    <section id="education" className="section section-light">
      <div className="container">
        <h2>Utbildning & Certifieringar</h2>
        
        <div className="timeline">
          {education.map((edu, index) => (
            <div key={index} className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <div className="timeline-date">{edu.period}</div>
                <h3 className="timeline-title">{edu.title}</h3>
                <h4 className="timeline-company">{edu.institution}</h4>
                <p className="timeline-description">{edu.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="certifications-section">
          <h3 style={{textAlign: 'center', marginTop: '4rem'}}>Certifieringar</h3>
          <div className="skills-grid" style={{marginTop: '2rem'}}>
            {certifications.map((cert, index) => (
              <div key={index} className="skill-category">
                <h4>{cert.name}</h4>
                <p style={{color: 'var(--text-tertiary)', marginBottom: '0.5rem'}}>{cert.issuer}</p>
                <span style={{color: 'var(--primary)', fontSize: 'var(--font-size-sm)'}}>{cert.year}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Education;